import { generateClient } from "aws-amplify/api";
import { deleteProjectDoc } from "db/queries/projectQueries";
import { recordSentry } from "utils/recordSentry";
import { deleteProjectLambda } from "../graphql/mutations";

async function deleteProjectFromDb(id: string, online: boolean) {
	try {
		if (online) {
			const client = generateClient({ authMode: "userPool" });
			const deleted = await client.graphql({
				query: deleteProjectLambda,
				authMode: "userPool",
				variables: {
					projectId: id,
				},
			});
			return deleted;
		} else {
			await deleteProjectDoc(id);
		}
	} catch (error) {
		recordSentry({ error, msg: `Error deleting project. Online: ${online}:` });
	}
}

export default deleteProjectFromDb;
